import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import type { RelevanceMode, RelevanceRating, RelevanceResultItem } from '../types';

const WHY_STRINGS = appStrings.modules.majorsGuide.careerRelevance.whyWeBuiltThisToolModal;
const RELEVANCE_STRINGS = appStrings.modules.majorsGuide.careerRelevance.relevanceLevelsModal;

const whyWeBuiltDetail = [
  WHY_STRINGS.subtitle,
  `${WHY_STRINGS.dataDrivenInsightsTitle}: ${WHY_STRINGS.dataDrivenInsightsDescription}`,
  `${WHY_STRINGS.makeInformedDecisionsTitle}: ${WHY_STRINGS.makeInformedDecisionsDescription}`,
].join('\n');

const relevanceLevelsDetail = [
  RELEVANCE_STRINGS.subtitle,
  `${RELEVANCE_STRINGS.highTitle}: ${RELEVANCE_STRINGS.highDescription}`,
  `${RELEVANCE_STRINGS.mediumTitle}: ${RELEVANCE_STRINGS.mediumDescription}`,
  `${RELEVANCE_STRINGS.lowTitle}: ${RELEVANCE_STRINGS.lowDescription}`,
].join('\n');

export const useAgentContext = (
  mode: RelevanceMode,
  selections: string[],
  visibleLevels: Set<RelevanceRating>,
  total: number,
  results: readonly RelevanceResultItem[],
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Header',
    description:
      'Page header showing dynamic title based on mode (e.g. "Career Paths → Majors Relevance"), description text, a "Why We Created This Tool" link, Instructions button, and a mode switch button to toggle between paths and majors mode.',
    detail: whyWeBuiltDetail,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Selection Card',
    description:
      'Card containing a MultiSelectSearchList where users search and select up to 5 career paths or majors. Items are grouped by category in a dropdown with checkboxes. Selected items appear as removable pill badges below the search input.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Relevance Filters',
    description:
      'Row of High/Medium/Low toggle badges for filtering results by relevance level. Includes a Clear button to reset all levels and an "Understanding Relevance Levels" button that opens an explanatory dialog.',
    detail: relevanceLevelsDetail,
  });

  const resultVariant = mode === 'paths' ? 'major' : 'career-path';

  useRegisterAgentContext({
    kind: 'nuggetList',
    description: `Relevance-ranked ${mode === 'paths' ? 'majors' : 'career paths'} matching the selected ${mode === 'paths' ? 'career paths' : 'majors'}.`,
    nuggets: results.map((r) => ({
      id: r.id,
      variant: resultVariant,
      title: r.name,
      metadata: {
        ratings: r.ratings,
        rationales: r.rationales,
      },
    })),
    data: {
      selectedItems: selections.length > 0 ? selections : null,
      visibleLevels: Array.from(visibleLevels),
      totalResults: total,
    },
  });
};
